import { IBrickInstanceTargetingAction } from '../../../../../utility/IBrickInstanceTargetingAction';

export class AgentListBrickSearchValueChanged {
   public static readonly type = '[AgentListBehaviour] Search value changed';

   constructor(public newSearchValue: string, public brickInstanceId: string) {}
}

export class AgentListAllFilterCleared {
   public static readonly type = '[AgentListBehaviour] agent list all filters cleared';

   constructor(public brickInstanceId: string) {}
}

export class AgentListEntrySelected implements IBrickInstanceTargetingAction {
   public static readonly type = '[Agent List Behaviour] agent list entry selected';

   constructor(public brickInstanceId: string, public userId: number) {}
}

export class AgentListSelectNextEntry implements IBrickInstanceTargetingAction {
   public static readonly type = '[Agent List Behaviour] agent list select next entry';

   constructor(public brickInstanceId: string, public direction: 'up' | 'down', public step = 1) {}
}
